import { css } from '@emotion/css';
import { Colors } from '@blueprintjs/core';

export const formStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  justify-content: space-around;
  background-color: ${Colors.LIGHT_GRAY3};
  border: 1px solid ${Colors.LIGHT_GRAY1};
  width: 100%;
  padding: 0.8em 0;
  margin-bottom: 0;
`;
